
import gsap from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { throttle } from "throttle-debounce";

const Animations = {
  init: () => {
    gsap.registerPlugin(ScrollTrigger);

    if (document.querySelector('.konfekt-page') || document.querySelector('.paska-page') || document.querySelector('.plata-arsins-page')) {
      return;
    }

    Animations.animateSections();
    Animations.animateHero();
    Animations.animateFooter();
    Animations.animateTimeline();

    Animations.animateItems(".productlist", ".card");
    Animations.animateItems(".productbanner:not(.producthero) .productbanner__right", ".card");
    Animations.animateItems(".boxlist", ".box");
    Animations.animateItems(".stjorn", ".stjorn__item");
    Animations.animateItems(".ads", ".augl");
    Animations.animateItems(".recipes", ".recipebox");
    Animations.animateItems(".docs", ".doc");
    Animations.animateItems(".news", ".newslist__item");

    Animations.parallaxProductBanner();
    Animations.parallaxSingleImage();

    // setTimeout(() => {
    //   document.querySelectorAll("img").forEach((image) => {
    //     image.addEventListener("load", () => {
    //       ScrollTrigger.refresh();
    //       console.log('asdf')
    //     });
    //   });
    // }, 500);
  },

  animateSections: () => {
    const firstLoad = !sessionStorage.getItem("loaded");
    document.querySelector(".layout__cover").classList.add("layout__cover--hidden");
    sessionStorage.setItem("loaded", JSON.stringify(true));
    const isMob = window.innerWidth < 992;

    document.querySelectorAll(".header, .section:not(.productstype)").forEach((section) => {
      if (isMob && (section.classList.contains("hero") || section.classList.contains("header"))) {
        return;
      }

      const isHeader = section.classList.contains("header");
      let delay = 0.2;
      let y = -75;
      let opacity = 0;

      if (!firstLoad && isHeader) {
        opacity = 1
        y = 0
      };

      if (section.classList.contains("productvariable")) delay = 0.4;
      if (section.classList.contains("productinfo")) delay = 0.6;

      gsap.fromTo(section.firstElementChild, {
        opacity,
        y,
      }, {
        clearProps: "all",
        delay,
        duration: 1.5,
        ease: "back.out",
        opacity: 1,
        y: 0,
        scrollTrigger: {
          start: "top 95%",
          toggleActions: "play none none reverse",
          trigger: section,
        },
      });
    });
  },

  animateHero: () => {
    const hero = document.querySelector(".hero");

    if (!hero) return;

    const handleMouseMove = (e) => {
      const x = e.touches ? e.touches[0].clientX : e.clientX;

      const isMobile = window.innerWidth < 992;

      const xPercent = (x / window.innerWidth - 0.5) * 100;
      const yPercent = 0;

      if (!isMobile) {
        hero.querySelectorAll(".swiper-slide-active .hero__image").forEach((element) => {
          gsap.to(element, {
            duration: 0.2,
            x: `${-xPercent / 40}%`,
            y: `${-yPercent / 40}%`,
            rotation: `${-xPercent / 40}`,
          });
        });
      } else {
        hero.querySelectorAll(".swiper-slide-active .hero__image").forEach((element) => {
          gsap.to(element, {
            clearProps: "all",
          });
        });
      }
    };

    const handleResize = () => {
      hero.querySelectorAll(".swiper-slide .hero__image").forEach((element) => {
        gsap.set(element, {
          clearProps: "all",
        });
      });
    };

    window.addEventListener("mousemove", throttle(60, handleMouseMove));
    window.addEventListener("resize", handleResize);
  },

  animateFooter: () => {
    gsap.fromTo(".footer", {
      opacity: 0,
    }, {
      clearProps: "all",
      duration: 1.5,
      ease: "power2.out",
      opacity: 1,
      scrollTrigger: {
        start: "top 90%",
        toggleActions: "play none none reverse",
        trigger: ".footer",
      },
    });
  },

  animateTimeline: () => {
    const timeline = document.querySelector(".saga");

    if (!timeline) return;

    timeline.querySelectorAll(".sagacard__container").forEach((card) => {
      gsap.fromTo(card, {
        opacity: 0,
        y: 150,
      }, {
        clearProps: "all",
        duration: 1.5,
        ease: "back.out",
        opacity: 1,
        y: 0,
        scrollTrigger: {
          start: "top 95%",
          toggleActions: "play none none reverse",
          trigger: card,
        },
      });
    });
  },

  animateItems: (listsClass, itemClass) => {
    document.querySelectorAll(listsClass).forEach((list) => {
      Animations.animateItemsList(list, itemClass);
    });
  },

  animateItemsList: (list, itemClass) => {
    gsap.fromTo(list.querySelectorAll(itemClass), {
      opacity: 0,
      y: 300,
      pointerEvents: "none",
      transition: "none",
    }, {
      clearProps: "all",
      pointerEvents: "none",
      transition: "none",
      duration: 1,
      ease: "power2.out",
      opacity: 1,
      stagger: 0.1,
      y: 0,
      scrollTrigger: {
        start: "top 95%",
        toggleActions: "play none none reverse",
        trigger: list.querySelector(".row:nth-of-type(2)"),
      },
    });
  },

  parallaxProductBanner: () => {
    document.querySelectorAll(".productbanner ").forEach((banner) => {
      const background = banner.querySelector(".productbanner__backgroundimage");
      const image = banner.querySelector(".productbanner__image");

      if (background) {
        gsap.to(background, {
          ease: "linear.none",
          y: -100,
          scrollTrigger: {
            start: "top 0",
            scrub: 1,
            trigger: banner,
          },
        });
      }

      if (image) {
        gsap.to(image, {
          ease: "linear.none",
          y: 50,
          scrollTrigger: {
            scrub: 1,
            start: "top 0",
            trigger: banner,
          },
        });
      }
    });
  },

  parallaxSingleImage: () => {
    const isMobile = window.innerWidth < 992;
    document.querySelectorAll(".parallaximage").forEach((image) => {
      gsap.to(image.querySelector("img"), {
        ease: "linear.none",
        y: isMobile ? "-5vh" : "-15vh",
        scrollTrigger: {
          end: "bottom 0",
          scrub: 1,
          start: "top 100%",
          trigger: image,
        },
      });
    });
  },

};

export default Animations;
